import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { CreateUserMutation, User, UserInput } from '#/graphql/types';
import { createUser } from '#/graphql/mutations'
import { get, omit, pick } from 'lodash';

const q = gql(createUser);

const useUserCreate = () => {
    const [mutation, result] = useMutation<CreateUserMutation>(q);
    const createUser = useCallback(
        async (user: UserInput) => {
            const response = await mutation({
                variables: {
                    data: pick(user, ['name', 'email', 'phone', 'role', 'address']),
                },
            });
            return get(response, 'data.createUser', undefined);
        },
        [mutation],
    );

    return { createUser, result };
};
// Used in the modules Form file
export default useUserCreate;
